import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ax from "../config";
import {openNotification} from "../../components/helpers/notification";

const initialState = {
  params: null,
  currentParam: null,
  isLoading: false,
  status: null
}

export const paramsAction = createAsyncThunk(
  'params/paramsAction',
  async (payload, { rejectWithValue }) => {
    try {
      let data;
      const url = '/api/admin/param';
      switch (payload.flag) {
        case 'get':
          ({data} = await ax.get(url, {params: payload.value}))
          return data

        case 'post':
          ({data} = await ax.post(url, payload.value))
          data && openNotification({
            type: 'success',
            message: `Версия успешно отредактирована`
          })
          break;

        default:
          break;
      }
    } catch (error) {
      return rejectWithValue(`Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
    }
  }
)

const ParamsSlice = createSlice({
  name: 'params',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(paramsAction.fulfilled, (state, action) => {

      action.payload && (state.params = action.payload)
      state.isLoading = false
      state.status = 'success'
    })
    builder.addCase(paramsAction.pending, (state, action) => {
      state.isLoading = true
      state.status = 'pending'
    })
    builder.addCase(paramsAction.rejected, (state, action) => {
      state.isLoading = false
      state.status = 'rejected'
      openNotification({
        type: "error",
        message: action.payload
      })
    })
  }
})

export const {} = ParamsSlice.actions;
export default ParamsSlice.reducer